import React from 'react';
import * as R from 'ramda';

import { NewProgressField } from 'resources/common';

const LabsProgressField = ({ record: student, course, cohort }) => {
  const hiddenUnits = R.pathOr([], [course, 'hidden_units'], cohort);
  const labs = R.pathOr([], [course, 'labs'], student);

  const getUnitId = R.path(['path', '3', 'id']);

  const isUnitHidden = (lab) => {
    const unitId = getUnitId(lab);
    return R.includes(unitId, hiddenUnits);
  };

  const visibleLabs = R.reject(isUnitHidden, labs);

  const isRequired = R.propEq('required', true);
  const requiredLabs = R.when(
    R.any(isRequired),
    R.filter(isRequired)
  )(visibleLabs);

  const total = R.length(requiredLabs);
  const completed = R.pipe(R.filter(R.has('attempts')), R.length)(requiredLabs);
  const text = `${completed}/${total}`;
  const progress = R.defaultTo(0, Math.round((100 * completed) / total));
  return <NewProgressField value={progress} text={text} />;
};

LabsProgressField.defaultProps = {
  label: 'Labs Progress',
};

export default LabsProgressField;
